export function deSrlz(input_data) {
    let market = {}
    input_data = "book|" + input_data
    let marketDtata = input_data.split('|');
    market.bookType = marketDtata[0];
    market.marketId = marketDtata[1];
    market.betDelay = marketDtata[2];
    market.status = marketDtata[3];
    market.inPlay = marketDtata[4];
    if (!!marketDtata[5] && marketDtata[5] !== "") {
        market.lastMatchTime = marketDtata[5];
    }
    if (!!marketDtata[6] && marketDtata[6] !== "") {
        market.updateTime = marketDtata[6];
    }
    if (!!marketDtata[7] && marketDtata[7] !== "") {
        market.sportingEvent = marketDtata[7] === "True" ? true : false;
    } else {
        market.sportingEvent = false;
    }
    if (!marketDtata[8]) {
        return false
    }
    let runnerData = marketDtata[8].split(',');
    let runners = [];
    Array.prototype.forEach.call(runnerData,(runner, i) => {
        let rnr = {};
        let rnrData = runner.split('~');
        let backData = !!rnrData[2] && rnrData[2].split('*').length > 0 ? rnrData[2].split('*') : null;
        let layData = !!rnrData[3] && rnrData[3].split('*').length > 0 ? rnrData[3].split('*') : null;
        rnr.selectionId = rnrData[0];
        rnr.status = rnrData[1];
        rnr.back = priceData(backData);
        rnr.lay = priceData(layData);
        runners.push(rnr)
    })
    market.runners = runners
    return market
}

export function priceData(data) {
    let newData = [];
    if (!!data) {
        Array.prototype.forEach.call(data,(pr, i) => {
            let pData = pr.split(':');
            let nData = { "price": pData[0], "size": pData[1], "line": !!pData[2] ? pData[2] : "0" };
            newData.push(nData);
        })
    }
    if (data === null) {
        newData = []
    }
    return newData;
}


export function toFixedDigit(amt,digit){
    let dgt = !!digit ? digit : 2
    let multi = 1
    for(let i=0;i<dgt;i++){
        multi = multi*10
    }
    let op = Math.round(amt*multi)/multi
    return op
}